import { cn } from '@/lib/utils';

/**
 * Shared styling for selectable "chip" toggles (event tags, event
 * requirements). Selected chips get a solid off-black border + text; unselected
 * chips are muted grey with a hover lift. Keeps the sibling chip sections
 * visually in sync.
 */
export function toggleChipClassName(isSelected: boolean, className?: string): string {
  return cn(
    'rounded-xs px-4 py-2 font-inter text-sm font-normal transition-[color,background-color,border-color,transform] hover:bg-dinnerplate-white-light active:scale-95 focus-visible:ring-2 focus-visible:ring-off-black focus-visible:ring-offset-1',
    isSelected
      ? 'border border-off-black text-off-black'
      : 'border border-grey-light text-grey hover:border-grey hover:text-off-black',
    className,
  );
}
